import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import React, { useEffect, useState } from 'react'

dayjs.extend(duration)

type CountdownProps = {
  regTime: string | Date | number;
  className?: string;
};

const Countdown: React.FC<CountdownProps> = ({ regTime, className = '' }) => {
  const targetTime = dayjs(regTime).add(10, 'day')

  const getTimeLeft = () => {
    const now = dayjs()
    const diff = targetTime.diff(now)

    if (diff <= 0) return null

    const dur = dayjs.duration(diff)
    return {
      days: dur.days(),
      hours: dur.hours(),
      minutes: dur.minutes(),
      seconds: dur.seconds(),
    }
  }

  const [timeLeft, setTimeLeft] = useState(getTimeLeft())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft())
    }, 1000)

    return () => clearInterval(interval)
  }, [regTime])

  if (!timeLeft) {
    return null
  }

  const { days, hours, minutes, seconds } = timeLeft

  return (
    <div>
      <p className={className}>Te quedan</p>
      <p className={className}>{days}d {hours}h {minutes}m {seconds}s</p>
    </div>
  )
}

export default Countdown
